module.exports = __webpack_public_path__ + "img/shoping_banner1.png";